import {useMessageContext} from "../../../contexts/MessageContext";
import {Box, Button, Divider, Paper, TextField, Typography} from "@mui/material";
import {saveCompany} from "../../../services/CompanyService";
import SaveIcon from '@mui/icons-material/Save';

const CompanyAboutTab = ({ company, setCompany, setRefresh, setLoader}) => {

  const {notificationHandler} = useMessageContext();

  return (
    <Paper
      component="form"
      onSubmit={(event => {
        event.preventDefault();
        setLoader(true);
        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());

        let body = {...company};
        body.aboutProductInformation = formJson.aboutProductInformation;
        body.aboutCompany = formJson.aboutCompany;
        body.authorInformation = formJson.authorInformation;

        saveCompany(body)
            .then(() => setRefresh(prv => !prv))
            .then(() => notificationHandler.success('Company Saved'))
            .finally(() => setLoader(false))
      })}
      sx={{ mt: 3, p: 3 }}
      elevation={1}
    >
      {/* About Product */}
      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2, fontWeight: 600, fontSize: "0.75rem", textTransform: "uppercase" }}>
        About Product
      </Typography>

      <TextField
          fullWidth
          size="small"
          multiline
          minRows={4}
          id="aboutProductInformation"
          name="aboutProductInformation"
          label="About Product Information"
          placeholder="Enter product information..."
          variant="outlined"
          defaultValue={company.aboutProductInformation}
          sx={{ mb: 2 }}
      />

      <Divider sx={{ my: 3 }} />

      {/* About Company */}
      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2, fontWeight: 600, fontSize: "0.75rem", textTransform: "uppercase" }}>
        About Company
      </Typography>

      <TextField
          fullWidth
          size="small"
          multiline
          minRows={4}
          id="aboutCompany"
          name="aboutCompany"
          label="About Company"
          placeholder="Enter company description..."
          variant="outlined"
          defaultValue={company.aboutCompany}
          sx={{ mb: 2 }}
      />

      <Divider sx={{ my: 3 }} />

      {/* Author Information */}
      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2, fontWeight: 600, fontSize: "0.75rem", textTransform: "uppercase" }}>
        Author Information
      </Typography>

      <TextField
          fullWidth
          size="small"
          multiline
          minRows={4}
          id="authorInformation"
          name="authorInformation"
          label="Author Information"
          placeholder="Enter author information..."
          variant="outlined"
          defaultValue={company.authorInformation}
          sx={{ mb: 2 }}
      />

      <Divider sx={{ my: 3 }} />

      {/* Actions */}
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          type="submit"
          variant="contained"
          startIcon={<SaveIcon />}
        >
          Save Changes
        </Button>
      </Box>
    </Paper>
  );
};

export default CompanyAboutTab;
